module.exports = __webpack_public_path__ + "front/img/b20.70b45713.jpg";